<template>
  <v-container fluid class="py-0">
    <v-row align="center" class="pb-2">
      <h1 class="title">Attributes</h1>
      <v-spacer></v-spacer>
      <v-tooltip bottom v-if="customDataTypeId">
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            fab
            dark
            color="primary"
            @click="onCreateNewAtrr"
            small
          >
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
        </template>
        <span>Create New Attribute</span>
      </v-tooltip>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="items"
          :items-per-page="5"
          class="elevation-1"
        >
          <template v-slot:item.actions="{ item }">
            <default-list-actions
              :item="item"
              hideView
              @editItem="onEditItem"
              @deleteItem="onDeleteItem"
            ></default-list-actions>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <c-data-type-attribute-edit-dialog
      :show="showEditDialog"
      @close="showEditDialog = false"
      v-model="editedItem"
      @input="onSaveItem"
    />
    <v-row v-if="debug">
      <v-col>
        <code>{{ items }}</code>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import gql from "graphql-tag";
import { removeGQLTypename } from "../../../../helpers";
import CDataTypeAttributeEditDialog from "./CDataTypeAttributeEditDialog.vue";
import { ListMixin } from "../../../../mixins/ListMixin";
import DefaultListActions from "../../shared/DefaultListActions.vue";
const ATTRS_QUERY = gql`
  query cdTypeAttributes($id: ID!) {
    customDataType(id: $id) {
      id
      attributes {
        edges {
          node {
            id
            name
            description
            type
            isRequired
            order
          }
        }
      }
    }
  }
`;
const CREATE_MUTATION = gql`
  mutation createCDTypeAttribute($input: CustomDataTypeAttributeInput!) {
    createCustomDataTypeAttribute(input: $input) {
      id
      name
      description
      type
      isRequired
      order
    }
  }
`;
const UPDATE_MUTATION = gql`
  mutation updateCDTypeAttribute($input: CustomDataTypeAttributeInput!) {
    updateCustomDataTypeAttribute(input: $input) {
      id
      name
      description
      type
      isRequired
      order
    }
  }
`;
const DELETE_MUTATION = gql`
  mutation deleteCDTypeAttribute($id: ID!) {
    deleteCustomDataTypeAttribute(id: $id) {
      id
    }
  }
`;
export default {
  name: "custom-data-types-attributes",

  props: {
    customDataTypeId: {
      type: String,
      deafult: () => "",
    },
  },

  components: { CDataTypeAttributeEditDialog, DefaultListActions },

  data() {
    return {
      debug: false,
      editedItem: null,
      showEditDialog: false,
      headers: [
        { text: "Name", value: "name" },
        { text: "Description", value: "description" },
        { text: "Type", value: "type" },
        { text: "Required", value: "isRequired" },
        { text: "Actions", value: "actions", sortable: false },
      ],
    };
  },

  computed: {
    items() {
      return this.id != "" && this.attributes && this.attributes.length > 0
        ? [...this.attributes]
        : [];
    },
  },

  methods: {
    onCreateNewAtrr() {
      this.editedItem = null;
      this.showEditDialog = true;
    },
    onEditItem(item) {
      this.editedItem = { ...item };
      this.showEditDialog = true;
    },
    onSaveItem(payload) {
      const mutation = payload.id ? UPDATE_MUTATION : CREATE_MUTATION;
      this.$apollo
        .mutate({
          mutation,
          variables: {
            input: {
              customDataTypeId: this.customDataTypeId,
              ...payload,
            },
          },
          refetchQueries: [
            {
              query: ATTRS_QUERY,
              variables: { id: this.customDataTypeId },
            },
          ],
        })
        .then(() => {
          this.$store.dispatch("showAppSnackbar", {
            msg: "Custom Data Type Attribute Saved.",
          });
        })
        .catch((err) => {
          const errorMsg = err.graphQLErrors.map((e) => e.message).join(", ");
          this.$store.dispatch("showAppSnackbar", {
            msg: errorMsg,
            color: "error",
          });
        });
    },
    onDeleteItem(item) {
      console.log("Delete Item", item);
      this.$apollo
        .mutate({
          mutation: DELETE_MUTATION,
          variables: { id: item.id },
          refetchQueries: [
            {
              query: ATTRS_QUERY,
              variables: { id: this.customDataTypeId },
            },
          ],
        })
        .then(() => {
          this.$store.dispatch("showAppSnackbar", {
            msg: "Custom Data Type Attribute Deleted.",
          });
        })
        .catch((err) => {
          const errorMsg = err.graphQLErrors.map((e) => e.message).join(", ");
          this.$store.dispatch("showAppSnackbar", {
            msg: errorMsg,
            color: "error",
          });
        });
    },
  },

  apollo: {
    attributes: {
      query: ATTRS_QUERY,
      variables() {
        return {
          id: this.customDataTypeId,
        };
      },
      update: (data) => {
        return data.customDataType.attributes.edges.map(removeGQLTypename);
      },
      fetchPolicy: "network-only",
      skip() {
        return !this.customDataTypeId;
      },
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/gt/admin/cd-types/CustomDataTypesAttributes.vue